export default __webpack_public_path__ + "static/1-1-2-0-2d320c254b74d4a031492a91b2ce2dbc.jpg";